import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { SecondAds, FirstAds, MobileUnderCalAds } from '../../Ads';
import { SERVER_URL } from './ConstantsWomenCalculator';
import { Ovulation_EndPoint } from './ConstantsWomenCalculator';
import { OvulationTableFull } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const TITLE = 'حاسبة التبويض - حساب أيام التبويض والجماع';
const DESCRIPTION = 'حساب أيام التبويض وفرص الحمل المناسبة لدى النساء ومعرفة الوقت المناسب للجماع من أجل حدوث الحمل باستخدام حاسبة التبويض.';
const KEYWORDS = 'حاسبة توقيت التبويض, حساب أيام التبويض, حاسبة الإباضة الدقيقة, فرص حدوث الحمل, موعد التبويض, زيادة فرص الحمل, فترة الإباضة, حساب التبويض للحمل, الدورة الشهرية';
const OG_URL = 'https://do-calculate.com/calculator/ar/ovulation/';
const apiEndpoint = `${SERVER_URL}/${Ovulation_EndPoint}`;
function OvulationCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [periodLength, setPeriodLength] = useState(1);
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculateOvulation = async () => {
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength, periodLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}><b>
                        <h1 style={{ fontSize: '15px' }}>   حاسبة التبويض | كيفية حساب أيام التبويض وفرص الحمل
                        </h1>
                    </b></div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                تُستخدم حاسبة التبويض لتحديد أيام التبويض لدى المرأة، وهي الأيام التي تمثل فترة الخصوبة المثلى، حيث تزيد فيها فرص حدوث الحمل بشكل كبير. تختلف مواعيد الحيض ومدد الدورة الشهرية بين النساء، مما يؤدي إلى تباين فترة التبويض ونافذة الخصوبة من امرأة إلى أخرى. في الدورة الشهرية القياسية التي تبلغ 28 يومًا، تبدأ فترة التبويض عادةً بعد حوالي 14 يومًا من اليوم الأول من الدورة الشهرية. يُذكر أن نافذة الخصوبة تمتد عادة لمدة تصل إلى خمسة أيام قبل التبويض وثلاثة أيام بعده، حيث يكون احتمال حدوث الحمل في ذروته.
                            </div>
                            <div>
                                حاسبة فترة الإباضة والخصوبة هي أداة مهمة تساعدك على اكتشاف الأوقات التي تكون فيها خصوبتك في أعلى مستوياتها، مما يضاعف فرصك في حدوث الحمل. ببساطة أدخلي المعلومات المطلوبة لتحصلي على تقدير دقيق لفترة التبويض وفترة الخصوبة الخاصة بك.
                            </div>
                            <hr />
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>   حاسبة أيام التبويض </h2>
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label ms-2" >
                                        <strong>أول يوم</strong> في آخر دورة شهرية لك:
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        متوسط الوقت بين الدورات
                                    </label>
                                    </b>
                                    <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">يوم</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculateOvulation}>إحسب </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">النتائج: </div></h4>
                                            <hr />
                                            <OvulationTableFull result={result}></OvulationTableFull>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">وصف حاسبة التبويض :</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>كيف يحدث الحمل لدى المرأة</h2>
                                <p>
                                    يحدث الحمل لدى المرأة عندما يقوم الحيوان المنوي للرجل بتخصيب البويضة الناضجة التي تخرج من مبيض المرأة خلال فترة التبويض. تعيش هذه البويضة لمدة قصيرة جداً تتراوح بين 12 إلى 24 ساعة. ولحدوث الحمل، يجب أن يتم الجماع في وقت التبويض، حيث تكون فرص حدوث الحمل في أعلى مستوياتها. تُستخدم حاسبة التبويض لتحديد هذه الفترة المثلى، مما يساعد في تنظيم النسل أو زيادة فرص الحمل.
                                </p>
                                <u><b>التبويض والتخصيب</b></u>
                                <br />
                                <p>
                                    في البشر، التبويض هو العملية التي يتم فيها إطلاق البويضة الناضجة من المبيض. يحدث التبويض عادةً قبل 14 يومًا من بداية الدورة الشهرية التالية. باستخدام حاسبة التبويض، يمكن توقع الأيام الأكثر خصوبة. الفترة بين اليوم 10 واليوم 18 من الدورة الشهرية هي الأكثر احتمالاً لحدوث التبويض. وخلال هذه الفترة، يمكن أن تبقى الحيوانات المنوية في الجهاز التناسلي للمرأة لمدة تصل إلى خمسة أيام، مما يزيد من فرص حدوث الحمل.
                                </p>
                                <u><b>توقع التبويض</b></u>
                                <br />
                                <p>
                                    حاسبة التبويض هي أداة مهمة لتوقع أيام الحيض وأيام التبويض الأكثر احتمالاً. تعتمد الحاسبة على معرفة اليوم الأول من الدورة الشهرية وطول الدورة الشهرية. باستخدام هذه المعلومات، يمكن حساب أيام التبويض بدقة، مما يساعد المرأة على تحديد أفضل وقت لممارسة الجماع لتحقيق الحمل أو تجنبه. يساعد هذا التوقع في زيادة فرص حدوث الحمل عند الرغبة في ذلك.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>طريقة حساب أيام التبويض</h2>
                                <p>
                                    تستمر فترة التبويض عادة لمدة تتراوح بين 12 إلى 24 ساعة. على الرغم من صعوبة تحديد هذه الفترة بدقة تامة، تُستخدم حاسبة التبويض لتقدير الوقت الأنسب. تعتمد العملية على حساب المدة بين الحيض والآخر، وإضافة هذه الفترة إلى تاريخ اليوم الأول من آخر دورة شهرية. بعد ذلك، يتم خصم أسبوعين من التاريخ المتوقع، مع الأخذ بعين الاعتبار خمسة أيام قبل ويومين بعد هذا التاريخ كفترة تقريبية للتبويض. حاسبة التبويض تساعد في تحديد هذه الفترة بدقة، مما يجعل من السهل معرفة الأيام الأنسب لحدوث الحمل.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>برنامج حساب أيام التبويض</h2>
                                <p>
                                    برنامج حاسبة أيام التبويض هو أداة تعتمد على البيانات المدخلة حول تاريخ أول يوم من آخر دورة شهرية وطول الدورة الشهرية. يقدم البرنامج معلومات دقيقة حول فترة الإباضة، مما يساعد النساء في تحديد الأيام التي تزيد فيها فرص حدوث الحمل أثناء الجماع. يمكن استخدام حاسبة التبويض سواء بالميلادي أو بالهجري، مما يوفر مرونة ودقة في حساب فترة التبويض.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>استخدام حاسبة الإباضة</h2>
                                <p>
                                    لاستخدام حاسبة التبويض، يجب على المرأة معرفة تاريخ اليوم الأول من آخر دورة شهرية ومدة الدورة الشهرية. من خلال إدخال هذه المعطيات في الحاسبة، يمكن حساب فترة الإباضة بسهولة ودقة خلال بضع ثوانٍ. يعد هذا الحساب أساسيًا لزيادة فرص حدوث الحمل أو لتنظيم النسل بطريقة طبيعية.
                                </p>
                                <br />
                                <hr />
                                <b>تاريخ اخر مراجعة :</b>28/02/2026
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default OvulationCalculator;
